import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { KTSVG } from '../../../_metronic/helpers'
import { useAuth } from '../../modules/auth'
import { Expediente } from '../../components/Expediente/Expediente'
import ReactPaginate from 'react-paginate'
import './BoletinJurisdiccional.css'
import PlanHeader from '../../components/PlanHeader/PlanHeader'

function BoletinJurisdiccional() {
  const API_URL = process.env.REACT_APP_API_URL
  const { currentUser } = useAuth()

  const [fechaLastUpdate, setFechaLastUpdate] = useState(new Date())
  const [loadingPage, setLoadingPage] = useState(false)

  const [expedientes, setExpedientes] = useState([])       // boletín
  const [misExpedientes, setMisExpedientes] = useState(null) // plan real, null para esperar carga

  const [searchValue, setSearchValue] = useState('')
  const [statusValue, setStatusValue] = useState('')

  /* ───────────────── FILTRO ───────────────── */
  let searchedExpedientes = []

  if (expedientes.length !== 0) {
    searchedExpedientes = expedientes.filter((expediente) => {
      if (searchValue !== '') {
        return expediente.expediente.includes(searchValue) ||
          expediente.parteActora.toLowerCase().includes(searchValue.toLowerCase())
      } else if (statusValue === 'TODOS' || statusValue === '') {
        return expediente
      } else {
        return String(expediente.notificacionVencida).includes(statusValue)
      }
    })
  }

  /* ──────────────── PAGINACIÓN ─────────────── */
  const [currentPage, setCurrentPage] = useState(1)
  const recordsPerPage = 30

  const indexOfLastRecord = currentPage * recordsPerPage
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
  const currentRecords = searchedExpedientes.slice(indexOfFirstRecord, indexOfLastRecord)
  const paginate = ({ selected }) => setCurrentPage(selected + 1)

  /* ──────────────── FECHAS ─────────────── */
  function addZero(i) {
    return i < 10 ? '0' + i : i
  }

  function formatoFecha(fecha, formato) {
    const meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
    const map = {
      dd: fecha.getDate(),
      mm: meses[fecha.getMonth()],
      yyyy: fecha.getFullYear(),
      HH: addZero(fecha.getHours()),
      MM: addZero(fecha.getMinutes())
    }
    return formato.replace(/mm|dd|HH|MM|yyyy/gi, (m) => map[m])
  }

  /* ─────────── EXPEDIENTES DEL PLAN ─────────── */
  const cargarMisExpedientes = () => {
    axios.get(`${API_URL}/app/expedientes/${currentUser.id}`)
      .then((response) => {
        setMisExpedientes(response.data)
      })
  }

  /* ─────────── BOLETÍN ─────────── */
  const boletinJurisdiccional = () => {
    setLoadingPage(true)
    axios.get(`${API_URL}/app/boletinJurisdiccional/${currentUser.id}`)
      .then((response) => {
        setExpedientes(response.data)
        setLoadingPage(false)
      })
  }

  const getLastUpdate = () => {
    axios.get(`${API_URL}/app/lastUpdate/`)
      .then((response) => {
        const t = response.data[0].lastUpdateTimestamp.split(/[- :]/)
        setFechaLastUpdate(new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]))
      })
  }

  useEffect(() => {
    getLastUpdate()
    boletinJurisdiccional()
    cargarMisExpedientes()
  }, [])

  return (
    <>
      {/* HEADER */}
      {console.log("Hola")}
      {misExpedientes !== null && (
        <PlanHeader
          totalExpedientes={misExpedientes.length}
          onRefresh={() => {
            cargarMisExpedientes()
            boletinJurisdiccional()
          }}
        />
      )}

      {/* Card container */}
      <div className='row gy-5 g-xl-8 card card-custom shadow mt-4 pb-10'>
        <div className='row p-6 pb-15'>
          <div className='col-md-6'>
            <h4>Boletín jurisdiccional</h4>
            <li className='d-flex align-items-center py-2'>
              <span className='bullet bullet-dot bg-success h-15px w-15px me-5'></span>
              <b>Última conexión al boletín:&nbsp;</b>
              {formatoFecha(fechaLastUpdate, 'dd de mm yyyy - HH:MM hrs')}
            </li>
          </div>
          <div className='col-md-3'>
            <select  
              aria-label="Selecciona" 
              id="select-custom" 
              name="estatus"
              className='form-select'>
              <option selected disabled>FILTRAR POR</option>
              <option value="true">SURTIÓ EFECTOS</option>
              <option value="false">AÚN NO SURTE EFECTOS</option>
              <option value="TODOS">TODOS</option>
            </select>
          </div>
          <div className='col-md-3 text-right'>
            <div className='form-group float-end pt-3'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 ms-0'
              />
              <input
                type='text'
                className='form-control form-control-flush ps-10 inicio-search-box mt-n10'
                name='search'
                placeholder='Buscar expediente...'
                value={searchValue}
                onChange={(event) => {
                  setSearchValue(event.target.value)
                  setCurrentPage(1)
                }}
              />
            </div>
          </div>
        </div>

        {/* Exp container */}
        <div className='row mb-10'>
          {!loadingPage && <Expediente expedientes={currentRecords} />}
          {loadingPage && (
            <div className='d-flex flex-center'>
              <h2>
                <span className='spinner-border spinner-border align-middle ms-2'></span>
                Cargando...
              </h2>
            </div>
          )}
        </div>
        <div className='row text-center'>
          <p>Mostrando {currentRecords.length} de {searchedExpedientes.length} resultados</p>
        </div>
        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(searchedExpedientes.length / recordsPerPage)}
          breakLabel={'...'}
          previousLabel={'< Anterior'}
          nextLabel={'Siguiente >'}
          containerClassName={'pagination'}
          pageLinkClassName={'page-number'}
          previousLinkClassName={'page-number'}
          nextLinkClassName={'page-number'}
          activeLinkClassName={'active'}
          forcePage={currentPage - 1}
        />
      </div>
    </>
  )
}

export { BoletinJurisdiccional }